import React from "react";
import "../styles/table.css";

export interface Column {
  key: string;
  label: string;
  render?: (row: any) => React.ReactNode;
  imageFolder?:
    | "users"
    | "subscribers"
    | "products"
    | "brands"
    | "subcategories"
    | "about"
    | "latestnews"
    | "career"
    | "team"
    | "software";
}

interface Props {
  columns?: Column[];
  data?: any[];
  loading?: string;
  selectedRowId?: number | null;
  onRowSelect?: (row: any) => void;
}

export default function DataTable({
  columns = [],
  data = [],
  selectedRowId,
  onRowSelect,
}: Props) {
  return (
    <div className="admin-table-wrapper">
      <table className="admin-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>

        {/* <tbody>
          {data.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length || 1}
                style={{ textAlign: "center", padding: "20px" }}
              >
                No data available
              </td>
            </tr>
          ) : (
            data.map((row, index) => (
              <tr
                key={index}
                className={selectedRowId === row?.id ? "row-selected" : ""}
                onClick={() => onRowSelect && onRowSelect(row)}
                style={{ cursor: "pointer" }}
              >
                {columns.map((col) => (
                  <td key={col.key}>
                    {col.render ? (
                      col.render(row)
                    ) : col.key === "image" || col.key === "image_path" ? (
                      row?.[col.key] ? (
                        <img
                          src={`${import.meta.env.VITE_LYRAZONE_IMAGE_URL}/uploads/${
                            col.imageFolder === "products"
                              ? `products/${row.id}`
                              : col.imageFolder || ""
                          }/${row[col.key]}`}
                          alt="Preview"
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "contain",
                            borderRadius: "8px",
                          }}
                        />
                      ) : (
                        "-"
                      )
                    ) : (
                      (row?.[col.key] ?? "-")
                    )}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody> */}
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length || 1}
                style={{ textAlign: "center", padding: "20px" }}
              >
                No data available
              </td>
            </tr>
          ) : (
            data.map((row, index) => (
              <tr
                key={index}
                className={selectedRowId === row?.id ? "row-selected" : ""}
                onClick={() => onRowSelect && onRowSelect(row)}
                style={{ cursor: "pointer" }}
              >
                {columns.map((col) => (
                  <td key={col.key}>
                    {col.render ? (
                      col.render(row)
                    ) : col.imageFolder && row?.[col.key] ? (
                      <img
                        src={`${import.meta.env.VITE_LYRAZONE_IMAGE_URL}/uploads/${
                          col.imageFolder === "products"
                            ? `products/${row.id}`
                            : col.imageFolder
                        }/${row[col.key]}`}
                        alt="Preview"
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "contain",
                          borderRadius: "8px",
                        }}
                      />
                    ) : (
                      (row?.[col.key] ?? "-")
                    )}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
